/**
 * Meghívó email — / parancs sablonok (HTML).
 * Placeholderek: {name}, {link}, {credits}, {days}, {days_estimate}
 */

/** Kredit kártya + funkció lista (email előnézet alsó blokkja). */
export const DEFAULT_INVITE_EXTRAS_HTML = `<table width="100%" cellpadding="0" cellspacing="0" style="margin-top:20px;background:#0f1419;border-radius:12px;border:1px solid #2563EB33;"><tr><td style="padding:20px;text-align:center;"><div style="color:#94a3b8;font-size:12px;text-transform:uppercase;letter-spacing:1px;">Induló ajándék</div><div style="color:#22C55E;font-size:36px;font-weight:bold;padding-top:8px;">{credits} kredit</div><div style="color:#cbd5e1;font-size:13px;padding-top:8px;line-height:1.5;">{days} napig automatikus feltöltés a cél egyenlegre<br/><span style="color:#94a3b8;">≈ {days_estimate} nap egy aktív hirdetés fenntartása (alap napi díj)</span></div></td></tr></table><ul style="color:#cbd5e1;font-size:14px;padding-left:18px;margin:16px 0 0;line-height:1.6;"><li style="margin-bottom:8px;">360° bemutató — videóból, telefonos felvételből</li><li style="margin-bottom:8px;">AI háttér a fotóknál — showroom hatás percek alatt</li><li style="margin-bottom:8px;">Kredites modell — csak amíg fut a hirdetésed, nincs rejtett havidíj</li></ul>`;

export const DEFAULT_INVITE_CTA_LABEL = "Regisztráció {credits} kredittel";

export const INVITE_EMAIL_PLACEHOLDERS = [
  { id: "name", label: "Címzett neve", token: "{name}" },
  { id: "link", label: "Regisztrációs link", token: "{link}" },
  { id: "credits", label: "Kredit összeg", token: "{credits}" },
  { id: "days", label: "Promó napok", token: "{days}" },
  { id: "days_estimate", label: "Becslés (nap)", token: "{days_estimate}" },
];

export const INVITE_EMAIL_SLASH_ITEMS = [
  {
    id: "partner-intro",
    title: "Partner bevezető",
    description: "Tisztelt partner + AutoPark pitch",
    keywords: "partner bevezeto intro",
    html: `<p>Tisztelt Partner!</p><p>Látva autókészletüket, szeretnénk felvenni Önökkel a kapcsolatot. Az <b>AutoPark</b> (autoparks.hu) célja, hogy az autókereskedés <b>modern, átlátható és kényelmes</b> legyen — magáneladók és kereskedők számára egyaránt.</p><p><b>Nem a hasznaltauto.hu helyett</b> ajánljuk, hanem <b>mellette</b>, mint második, modernebb webes csatorna — <b>külön szerződés nélkül</b>, a nyilvános ÁSZF alapján.</p>`,
  },
  {
    id: "features-bullets",
    title: "Funkciók (lista)",
    description: "Chat, összehasonlítás, 360°, AI, Meta…",
    keywords: "funkcio lista bullet",
    html: `<ul><li><b>Modern weboldal</b> — prémium megjelenés</li><li><b>Élő chat</b> — érdeklődés az oldalon</li><li><b>Összehasonlítás és kedvencek</b></li><li><b>360° bemutató</b> és <b>AI háttércsere</b></li><li><b>Facebook csoportok</b> + opcionális <b>Meta hirdetés</b></li><li><b>Kredit rendszer</b> — autónként döntesz a kiadásokról</li></ul>`,
  },
  {
    id: "pricing-block",
    title: "Árak (kredit)",
    description: "200 feladás, 10/nap, kiegészítők",
    keywords: "ar kredit pricing",
    html: `<p><b>Hirdetés:</b> feladás 200 kredit, ezután 10 kredit/nap, amíg fenn van az autó.</p><p><b>Kiegészítők (példa):</b> 360° — 70 kr · AI háttér — 50 kr · list boost — 30 kr/hét · TOP — 50 kr/hét · Facebook megosztás — 200 kr · Meta kampány — 1500 kr/hét.</p>`,
  },
  {
    id: "pricing-table",
    title: "Árak táblázat",
    description: "2 oszlopos kredit táblázat (email)",
    keywords: "ar tabla table pricing",
    html: `<table cellpadding="0" cellspacing="0" style="border-collapse:collapse;width:100%;margin:14px 0;font-size:14px;"><thead><tr><th style="border:1px solid #475569;padding:8px 10px;background:#1e293b;color:#f8fafc;text-align:left;">Tétel</th><th style="border:1px solid #475569;padding:8px 10px;background:#1e293b;color:#f8fafc;text-align:left;">Kredit</th></tr></thead><tbody><tr><td style="border:1px solid #475569;padding:8px 10px;color:#e2e8f0;">Hirdetés feladása</td><td style="border:1px solid #475569;padding:8px 10px;color:#e2e8f0;">200</td></tr><tr><td style="border:1px solid #475569;padding:8px 10px;color:#e2e8f0;">Napi fenntartás (aktív hirdetés)</td><td style="border:1px solid #475569;padding:8px 10px;color:#e2e8f0;">10 / nap</td></tr><tr><td style="border:1px solid #475569;padding:8px 10px;color:#e2e8f0;">360° bemutató</td><td style="border:1px solid #475569;padding:8px 10px;color:#e2e8f0;">70</td></tr><tr><td style="border:1px solid #475569;padding:8px 10px;color:#e2e8f0;">AI háttércsere</td><td style="border:1px solid #475569;padding:8px 10px;color:#e2e8f0;">50</td></tr><tr><td style="border:1px solid #475569;padding:8px 10px;color:#e2e8f0;">Meta hirdetés (heti)</td><td style="border:1px solid #475569;padding:8px 10px;color:#e2e8f0;">1500</td></tr></tbody></table>`,
  },
  {
    id: "pilot-500",
    title: "Pilot 500 kredit",
    description: "Regisztrációs ajánlat + link",
    keywords: "pilot 500 kredit link",
    html: `<p><b>Pilot ajánlat:</b> regisztráció után <b>{credits} kredit</b> — a promó időszak alatt ({days} nap) az egyenleg a szabályok szerint visszatölthető, így kockázat nélkül kipróbálhatják a fő funkciókat.</p><p>Regisztráció: <a href="{link}">{link}</a></p>`,
  },
  {
    id: "cta-closing",
    title: "Zárás + CTA",
    description: "Kérdés, visszajelzés",
    keywords: "zaras cta keres",
    html: `<p>Ha nyitottak a próbára, kérjük, regisztráljanak a fenti linken. Kérdés esetén szívesen válaszolunk — visszajelzéseiket nagyra értékeljük.</p><p>Tisztelettel,<br/>Az AutoPark csapata</p>`,
  },
  {
    id: "greeting",
    title: "Megszólítás",
    description: "Kedves {name}",
    keywords: "kedves udv",
    html: `<p>Kedves {name}!</p>`,
  },
  {
    id: "ha-beside",
    title: "HA mellé (kiemelt)",
    description: "Nem helyettesítjük",
    keywords: "hasznaltauto melle",
    html: `<p>Fontos: <b>nem az a célunk, hogy elvigyük a forgalmat a hasznaltauto.hu-ról</b>, hanem hogy <b>mellette</b> kipróbálják ezt az új csatornát.</p>`,
  },
  {
    id: "credit-card-block",
    title: "Kredit kártya",
    description: "Zöld {credits} promó doboz",
    keywords: "kredit kartya induló ajandek",
    html: `<table width="100%" cellpadding="0" cellspacing="0" style="margin-top:20px;background:#0f1419;border-radius:12px;border:1px solid #2563EB33;"><tr><td style="padding:20px;text-align:center;"><div style="color:#94a3b8;font-size:12px;text-transform:uppercase;letter-spacing:1px;">Induló ajándék</div><div style="color:#22C55E;font-size:36px;font-weight:bold;padding-top:8px;">{credits} kredit</div><div style="color:#cbd5e1;font-size:13px;padding-top:8px;line-height:1.5;">{days} napig automatikus feltöltés a cél egyenlegre<br/><span style="color:#94a3b8;">≈ {days_estimate} nap egy aktív hirdetés fenntartása (alap napi díj)</span></div></td></tr></table>`,
  },
  {
    id: "pilot-feature-bullets",
    title: "Pilot funkciók (3 pont)",
    description: "360°, AI, kredit modell",
    keywords: "pilot bullet lista funkcio",
    html: `<ul style="color:#cbd5e1;font-size:14px;padding-left:18px;margin:16px 0 0;line-height:1.6;"><li style="margin-bottom:8px;">360° bemutató — videóból, telefonos felvételből</li><li style="margin-bottom:8px;">AI háttér a fotóknál — showroom hatás percek alatt</li><li style="margin-bottom:8px;">Kredites modell — csak amíg fut a hirdetésed, nincs rejtett havidíj</li></ul>`,
  },
];
